import Boto from 'components/3catinfo/Boto';
import styles from './botons.module.scss';

const Botons = (props) => {

    const TENDENCIES_CLIMATIQUES = 'tendencies-climatiques';

    return (
        <div className={styles.contentBotons}>
            <Boto
                estil='transparent'
                text='Tendències a Catalunya'
                icona='fletxa_simple_dreta'
                className={styles.boto}
                route={{
                    type: 'web_3catinfo_estatiques_subseccio',
                    slug: TENDENCIES_CLIMATIQUES,
                    slug2: 'tendencies-catalunya'
                }}
                isIconaBlanc={false}
            />
            <Boto
                estil='transparent'
                text='Tendències al Mediterrani'
                icona='fletxa_simple_dreta'
                className={styles.boto}
                route={{
                    type: 'web_3catinfo_estatiques_subseccio',
                    slug: TENDENCIES_CLIMATIQUES,
                    slug2: 'tendencies-mediterrani'
                }}
                isIconaBlanc={false}
            />
            <Boto
                estil='transparent'
                text='Tendències al Món'
                icona='fletxa_simple_dreta'
                className={styles.boto}
                route={{
                    type: 'web_3catinfo_estatiques_subseccio',
                    slug: TENDENCIES_CLIMATIQUES,
                    slug2: 'tendencies-mon'
                }}
                isIconaBlanc={false}
            />
        </div>
    );
};

export default Botons;
